import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {
  AuthRequestInfo,
  Maybe,
} from '../../../../../../graphql/generated/types';
import {SelfCertRequestParams} from '../../../../../../selfCert/SelfCertRequestParams.interface';

export interface SelectState {
  authRequestInfo: Maybe<Pick<AuthRequestInfo, 'authUrl'>>;
  selfCertRequestParams?: SelfCertRequestParams;
}

const initialState: SelectState = {
  authRequestInfo: undefined,
};

export const selectSlice = createSlice({
  name: 'select',
  initialState,
  reducers: {
    setAuthRequestInfo: (
      state,
      action: PayloadAction<Maybe<Pick<AuthRequestInfo, 'authUrl'>>>
    ) => {
      state.authRequestInfo = action.payload;
    },
    setSelfCertRequestParams: (
      state,
      action: PayloadAction<SelfCertRequestParams>
    ) => {
      state.selfCertRequestParams = action.payload;
    },
    clearSelectState: state => {
      state.authRequestInfo = undefined;
      state.selfCertRequestParams = undefined;
    },
  },
});

export const {setAuthRequestInfo, setSelfCertRequestParams, clearSelectState} =
  selectSlice.actions;
